define('app/components/play_template.element',[

    'lodash',

    'app.env',
    'app/components/ractivejs.play',
    'app/components/play_template.element.view'

  ],
  function (
    _,
    ENV,
    BaseView,
    ElementView
  ) {

    var LOG_LABEL = 'PLAY ELM'

    var viewCache = {} // simple provider and cache for all element views -- key = elementCId

    return BaseView.extend({
      template: '#PlayElementWrapper-template',
      // settings
      data: function () {
        return {
          elementCId: null,
          elementId: null,
          elmType: null,
          elmDisplayLabel: null,
          pageCId: null,
          $ui: null,
          id: null,

          status: null,

          _guid: null
        }
      },

      subView: null,
      subViewStatus: null,

      // decorators & components
      decorators: {},
      components: {},

      // helper
      _getView: function (viewId) {
        var _this = this

        viewId = viewId || _this.get('elementCId')

        if (!viewId) {
          _this.teardown()
          //console.warn(LOG_LABEL, "element cid in baseview missing!");
          return
        }

        if (_this.subView && _this.subView.vid == viewId) {
          return
        }

        var subView = viewCache[viewId],
          data = {
            elementCId: viewId
          }

        if (!subView) {
          subView = viewCache[viewId] = new ElementView({ data: function () { return data } })
          subView.vid = viewId

        } else {
          //subView.set(data);

        }

        if (!subView) {
          console.warn(LOG_LABEL, 'element eview not found', viewId)
          return
        }

        if (_this.subView) { //} && _this.subView._frame && _this.subView._frame._guid === _this._guid){
          _this.subViewStatus.cancel()
          _this.subView.detach() //insert($('<div/>'));
        }

        //subView._frame = _this;
        delete (_this.subView)

        _this.set('elementId', subView.elm.id)
        _this.set('elmType', subView.get('elm.type'))
        _this.set('elmDataLabel', subView.get('elm.info.data_label'))

        _this.subViewStatus = subView.observe('status', function (newStatus) {
          _this.set('status', newStatus)
        })

        _this.subView = subView
        if (!subView.fragment.rendered) {
          subView.render($('<div/>'))
        }
        subView.insert(_this.find('.se_item'))

      },

      // actions

      // events
      oninit: function () {
        var _this = this

        _this.set('_guid', _this._guid)
        _this.on('view.ready', function () { // forward "view.ready" event to subView
          if (_this.subView) {
            _this.subView.fire('view.ready')
          }
        })

      },
      onrender: function () {
        var _this = this
        _this.observe('elementCId', _this._getView)

      },
      oncomplete: function () {
        var _this = this
      },
      ondetach: function () {
        var _this = this

        if (_this.subView) {
          _this.subView.detach()
        }
      },
      onteardown: function () {
        var _this = this

        if (_this.subView) {
          _this.subView.teardown()
        }
      }

    })
  })


;
